import React from "react";
import styles from "../tasks/OffSiteTasks.module.css";

export default function OffSiteReordersTasks() {
    return <div className={styles.Title}>Reorders</div>;
}
